import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AppContainer from '../containers/app';


class App extends Component {
    render() {
        return(
            <BrowserRouter>
                <Switch>
                    <Route path="/" component={AppContainer} />
                </Switch>
            </BrowserRouter>
        )
    }
}

const mapStateToProps = state => {
    return {
        session: state.session
    };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/appWrap.js